import {
  GISSTANDINCONSISTENCY_FIELDS,
  GISSTANDINCONSISTENCY_MENU_CATEGORY,
  GISSTANDINCONSISTENCY_MENU_SUBCATEGORY,
  GISSTANDINCONSISTENCY_PERMISSION,
} from '../gis-stand-inconsistency/gis-stand-inconsistency.config';

export const GISSTANDINCONSISTENCYONLYINZENDRA_FIELDS = GISSTANDINCONSISTENCY_FIELDS;

export const GISSTANDINCONSISTENCYONLYINZENDRA_CONFIG = {
  entityName: 'GisStandInconsistencyOnlyInZendra',
  localizationKey: 'Geographic::Entity.GisStandInconsistency.OnlyInZendra',
  fields: GISSTANDINCONSISTENCYONLYINZENDRA_FIELDS,
  permission: GISSTANDINCONSISTENCY_PERMISSION,
  showInMenu: false,
  menuCategory: GISSTANDINCONSISTENCY_MENU_CATEGORY,
  menuSubcategory: GISSTANDINCONSISTENCY_MENU_SUBCATEGORY,
};